import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    modules: [],
    features: [],
    customerPrices: {},
    loading: false,
    error: null,
    feedback: { open: false, message: "", severity: "info" },
};

const fgModuleSlice = createSlice({
    name: "fgModules",
    initialState,
    reducers: {
        modulesLoading(state) {
            state.loading = true;
        },
        modulesReceived(state, action) {
            state.modules = action.payload;
            state.loading = false;
        },
        featuresReceived(state, action) {
            state.features = action.payload;
            state.loading = false;
        },
        customerPricesReceived(state, action) {
            const { versionId, prices } = action.payload;
            state.customerPrices[versionId] = prices;
            state.loading = false;
        },
        genericSuccess(state, action) {
            state.loading = false;
            state.feedback = { open: true, message: action.payload, severity: "success" };
        },
        apiError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.feedback = {
                open: true,
                message: `Ein Fehler ist aufgetreten: ${action.payload}`,
                severity: "error",
            };
        },
        clearFeedback(state) {
            state.feedback.open = false;
        },
    },
});

export const { actions } = fgModuleSlice;
export default fgModuleSlice.reducer;
